import { VendorRentalEditPage } from "@/features/vendor-app/pages/VendorRentalEditPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/vendor/rental/$vendorConsignmentRentalPaymentID/edit",
)({
	component: VendorRentalEditPage,
});
